import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';

import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressRouterModule } from '@ngx-progressbar/router';
import { NgProgressHttpModule } from '@ngx-progressbar/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { select, Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { reducers, metaReducers } from './store/reducers';
import { UserEffects } from './store/user/effects';
import { AppStateEffects } from './store/settings/effects';
import { AuthService } from './services/auth/jwt/auth.service';
import { JwtAuthInterceptor } from './services/auth/jwt/jwt-auth.interceptor';
import { JsonSchemaRendererModule } from './components/renderer/json-schema-renderer.modul';
import { WorkflowModule } from '@workflow/workflow.module';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';
import { ResourceLibraryService } from './services/resource-library/resource-library.service';
import { CustomMarkdownRenderer } from './services/resource-library/custom-markown-renderer';
import * as Reducers from './store/reducers';
import {distinctUntilKeyChanged} from 'rxjs/operators';
import { ElementsModule } from './components/elements/elements.module';
import { TappingPenMonitorService } from '@app/workflow/components/questionnaire/questionnaire-item/special-question/tapping-test/tapping-pen-monitor.service';


// locale registration
import { DecimalPipe, registerLocaleData } from '@angular/common';
import { default as localeEn } from '@angular/common/locales/en';
import { default as localeDe } from '@angular/common/locales/de';
import { NZ_I18N, en_US as localeZorro, NZ_DATE_LOCALE } from 'ng-zorro-antd/i18n';
import { enUS as localeDateFns } from 'date-fns/locale';

class DynamicLocale {
	private locale = 'en';
	constructor(private store: Store<unknown>) {
		this.store.pipe(
			select(Reducers.getSettings),
			distinctUntilKeyChanged('locale'),
		).subscribe(state => {
			switch (state.locale) {
				default:
				case 'en-US':
					this.locale = 'en';
					break;
				case 'de-DE':
					this.locale = 'de';
					break;
			}
		});
	}

	public toString(): string {
		return this.locale;
	}

	toLowerCase(): string {
		return this.locale.toLowerCase();
	}
}
const LOCALE_PROVIDERS = [
	{ provide: LOCALE_ID, useClass: DynamicLocale, deps: [Store] },
	{ provide: NZ_I18N, useValue: localeZorro },
	{ provide: NZ_DATE_LOCALE, useValue: localeDateFns },
];
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe, 'de');


@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		HttpClientModule,
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		AppRoutingModule,
		WorkflowModule,
		JsonSchemaRendererModule,

		// translate
		TranslateModule.forRoot(),

		//elements
		ElementsModule,

		// ngrx
		StoreModule.forRoot(reducers, {metaReducers}),
		EffectsModule.forRoot([UserEffects, AppStateEffects]),
		StoreRouterConnectingModule.forRoot(),

		// nprogress
		NgProgressModule.withConfig({
			thick: true,
			spinner: false,
			color: '#0190fe'

		}),
		NgProgressRouterModule,
		NgProgressHttpModule,

		MarkdownModule.forRoot({
			markedOptions: {
				provide: MarkedOptions,
				useFactory: (resourceLibraryService: ResourceLibraryService) => {
					return {
						renderer: new CustomMarkdownRenderer(resourceLibraryService)
					};
				},
				deps: [ResourceLibraryService]
			}
		}),
	],
	providers: [
		// auth services
		AuthService,
		{ provide: HTTP_INTERCEPTORS, useClass: JwtAuthInterceptor, multi: true },
		{ provide: Window, useValue: window },
		DecimalPipe,
		// locale providers
		...LOCALE_PROVIDERS
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	// Services beim Start der Anwendung Initialisieren
	constructor(public tappingPenMonitor: TappingPenMonitorService) {}
}
